/* ============================================================
   鵠屋EC ブログ記事 商品グリッド

   通常：    【商品一覧：collection-handle】
   イベント：【イベント商品一覧：collection-handle】
   ============================================================ */

(() => {
  if (window.__kuguiArticleProductGridReady) return;
  window.__kuguiArticleProductGridReady = true;

  const ARTICLE_BODY_SELECTOR = '[data-section-type="article"] > .rte';

  const GRID_CONFIG = {
    standard: {
      sectionId: 'kugui-article-product-grid',
      gridSelector: '.kugui-article-product-grid__inner'
    },
    event: {
      sectionId: 'kugui-article-event-product-grid',
      gridSelector: '.kugui-article-event-product-grid__inner'
    }
  };

  const MARKER_PATTERNS = [
    {
      type: 'event',
      pattern: /^【イベント商品一覧[：:]([^】]+)】$/
    },
    {
      type: 'standard',
      pattern: /^【商品一覧[：:]([^】]+)】$/
    }
  ];

  function getMarkerData(text) {
    const label = (text || '')
      .replace(/\u00A0/g, ' ')
      .replace(/\s+/g, '')
      .trim();

    for (const marker of MARKER_PATTERNS) {
      const match = label.match(marker.pattern);
      if (!match) continue;

      const handle = match[1].trim();
      if (!handle) return null;

      return {
        type: marker.type,
        handle
      };
    }

    return null;
  }

  async function loadProductGrid(target, markerData) {
    if (!target || !markerData) return;

    const { type, handle } = markerData;
    const config = GRID_CONFIG[type];

    if (!config || !handle) return;

    if (
      target.dataset.kuguiCollectionStatus === 'loading' ||
      target.dataset.kuguiCollectionStatus === 'loaded'
    ) {
      return;
    }

    target.dataset.kuguiCollection = handle;
    target.dataset.kuguiCollectionMode = type;
    target.dataset.kuguiCollectionStatus = 'loading';
    target.setAttribute('aria-busy', 'true');

    const root =
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';

    const url = new URL(
      root + 'collections/' + encodeURIComponent(handle),
      window.location.origin
    );

    url.searchParams.set('section_id', config.sectionId);

    /* 未公開テーマのプレビュー中は preview_theme_id を引き継ぐ。 */
    const previewThemeId = new URLSearchParams(window.location.search).get(
      'preview_theme_id'
    );

    if (previewThemeId) {
      url.searchParams.set('preview_theme_id', previewThemeId);
    }

    try {
      const response = await fetch(url.toString(), {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) {
        throw new Error(
          `Section request failed: ${response.status} / ${url.toString()}`
        );
      }

      const html = await response.text();
      const renderedDocument = new DOMParser().parseFromString(
        html,
        'text/html'
      );

      const productGrid = renderedDocument.querySelector(config.gridSelector);

      if (!productGrid) {
        throw new Error('Product grid was not found in rendered section.');
      }

      target.replaceChildren(productGrid);
      target.classList.add('kugui-article-product-grid');

      if (type === 'event') {
        target.classList.add('kugui-article-product-grid--event');
      }

      target.dataset.kuguiCollectionStatus = 'loaded';
    } catch (error) {
      target.dataset.kuguiCollectionStatus = 'error';
      console.error('[Kugui Article Collection]', type, handle, error);
    } finally {
      target.removeAttribute('aria-busy');
    }
  }

  function replaceMarkerNode(node, markerData) {
    if (!node || !node.parentNode || !markerData) return;

    const target = document.createElement('div');
    node.parentNode.replaceChild(target, node);
    loadProductGrid(target, markerData);
  }

  function scanArticleBody(articleBody) {
    /*
     * Shopifyリッチテキストでは独立行が <p> 以外になる場合もあるため、
     * p / div / section を確認する。
     */
    const candidates = Array.from(
      articleBody.querySelectorAll('p, div, section')
    );

    candidates.forEach((element) => {
      if (!element.isConnected) return;

      const markerData = getMarkerData(element.textContent);
      if (!markerData) return;

      /* 親子双方が同じマーカー扱いになる場合は、内側だけを置換する。 */
      const hasInnerMarker = Array.from(
        element.querySelectorAll('p, div, section')
      ).some((child) => !!getMarkerData(child.textContent));

      if (hasInnerMarker) return;

      replaceMarkerNode(element, markerData);
    });

    /* 本文直下のテキストノードとして残った場合にも対応する。 */
    Array.from(articleBody.childNodes).forEach((node) => {
      if (node.nodeType !== Node.TEXT_NODE) return;

      const markerData = getMarkerData(node.textContent);
      if (!markerData) return;

      replaceMarkerNode(node, markerData);
    });
  }

  function initProductGrids(root = document) {
    const articleBodies = [];

    if (
      root.nodeType === 1 &&
      root.matches &&
      root.matches(ARTICLE_BODY_SELECTOR)
    ) {
      articleBodies.push(root);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll(ARTICLE_BODY_SELECTOR).forEach((body) => {
        articleBodies.push(body);
      });
    }

    articleBodies.forEach(scanArticleBody);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initProductGrids(), {
      once: true
    });
  } else {
    initProductGrids();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initProductGrids(event.target);
  });
})();
